import React, { useState, forwardRef } from "react";
import { Grid, Box, Tabs, Tab, AppBar, Typography } from "@material-ui/core";
import { Button, Link } from '../../components/Wrappers'
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
// components
import PageTitle from "../../components/PageTitle";
import Widget from "../../components/Widget";
import { withStyles } from '@material-ui/core/styles';
import AccountsTable from '../../components/Account/AccountsTable';


// Icons
import {
    Add as AddIcon,
    Chat as ChatIcon,
    MoreVert as MoreVertIcon,
    History as  HistoryIcon
} from '@material-ui/icons'

import useStyles from './styles';
import config from '../../config';

const Accounts = forwardRef((props, ref) => {
  // global
  const classes = useStyles();
  const history = useHistory();

  var [showTestntel, setShowTestntel] = useState(true);
  var [showPortal, setShowPortal] = useState(false);
  var [showAll, setShowAll] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  function handleTabChange(event, newValue) {
    setShowTestntel(newValue === 0);
    setShowPortal(newValue === 1);
    setShowAll(newValue === 2);
    setTabValue(newValue);
  }


  return (
    <>
      {(props.id === null || props.id === undefined || props.id <= 0) && <PageTitle title="Accounts List" />}
      <Grid container spacing={4}>
      <Grid item xs={12}>
      <AppBar position="static" color="default" style={{ marginTop: 10 }}>
          <Tabs value={tabValue}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth">
            <Tab {...a11yProps(0)} label="TESTntel Accounts"
                                   value={0}/>
            <Tab {...a11yProps(1)}
                         label="Customer Portal Accounts"
                         value={1}
                       />
            <Tab {...a11yProps(2)} label="All Accounts"
                                   value={2}/>
          </Tabs>
        </AppBar>
        <TabPanel value={tabValue} index={0}>
           {showTestntel && <AccountsTable />}
         </TabPanel>
         <TabPanel value={tabValue} index={1}>
          {showPortal && <AccountsTable portalOnly={true} />}
        </TabPanel>
         <TabPanel value={tabValue} index={2}>
           {showAll && <AccountsTable all={true}/>}
         </TabPanel>
      </Grid>
      </Grid>
    </>
  );
});

export default Accounts;
